import { _t, enableSceneTransmission } from '../../frame-graph/transmission.js';
import { makeRefractionRttExt } from './fragments/refraction-rtt-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

let _dispersionSampleWgsl;
function _setDispersionSampleWgsl(wgsl) {
  _dispersionSampleWgsl = wgsl;
}
function registerPbrTransmission(scene, engine, meshes) {
  let hasTransmissionRefraction = false;
  for (let i = 0; i < meshes.length && !hasTransmissionRefraction; i++) {
    const mat = meshes[i].material;
    hasTransmissionRefraction = !!mat?._transmissive && (mat._subsurface?.refraction?.intensity ?? 0) > 0;
  }
  if (!hasTransmissionRefraction) {
    return;
  }
  scene._p?.(_t(scene, engine)) || enableSceneTransmission(scene, engine);
  _registerPbrExt(makeRefractionRttExt(_dispersionSampleWgsl));
}

export { _setDispersionSampleWgsl, registerPbrTransmission };
//# sourceMappingURL=pbr-transmission-ext.js.map
